import React from 'react';
import PropTypes from 'prop-types';
import { withTheme } from 'styled-components';

const UnreadMessage = ({
  size, color, theme, iconTitle,
}) => {
  const iconColor = color || (theme && theme.iconColor);
  return (
    <svg viewBox="0 0 28.42819 18.24669" width={size} height={size} stroke={iconColor} fill={iconColor}>
      <title>{iconTitle}</title>
      <g id="Layer_2" data-name="Layer 2">
        <g id="Layer_1-2" data-name="Layer 1">
          <path d="M28.36847,17.21509a1.05629,1.05629,0,0,0,.028-.13843V1.13574a1.06876,1.06876,0,0,0-.0351-.17352.74651.74651,0,0,0,.00092-.43683A.75055.75055,0,0,0,27.64649,0H.78662a.74321.74321,0,0,0-.7149.9624,1.06662,1.06662,0,0,0-.0351.17334V17.07666a1.0628,1.0628,0,0,0,.02515.12415.74773.74773,0,0,0,.98151.98547,1.05536,1.05536,0,0,0,.12909.02612H27.26074a1.06184,1.06184,0,0,0,.14893-.03015.73183.73183,0,0,0,.9588-.96716ZM19.27,10.04193l6.58441,6.67047H2.57892l6.58441-6.67047L1.53662,15.93732V2.18634l12.25147,8.53485a.74926.74926,0,0,0,.85742,0l12.251-8.53479V15.93713ZM25.25781,1.5,14.19354,9.57794,3.1753,1.5Z" />
        </g>
      </g>
    </svg>
  );
};

UnreadMessage.propTypes = {
  color: PropTypes.string,
  iconTitle: PropTypes.string,
  size: PropTypes.number,
  theme: PropTypes.object,
};

UnreadMessage.defaultProps = {
  color: null,
  iconTitle: null,
  size: 26,
  theme: null,
};

export default withTheme(UnreadMessage);
